import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import React from "react";
import PromoTab from "./PromoTab";

const PromoCode = () => {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <PromoTab />
      <Footer />
    </DashboardLayout>
  );
};

export default PromoCode;
